//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faCalendar,
  faPenNib,
  faMailbox,
} from '@fortawesome/pro-regular-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';

export default {
  name: 'AboutPage',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    ColumnSection: () => import('@/components/core/elements/ColumnSection.vue'),
    SubscribeWebinar: () => import('@/components/subscribe/SubscribeWebinar.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    FeaturedInList: () => import('@/components/about/FeaturedInList.vue'),
  },
  data() {
    return {
      faCalendar,
      faPenNib,
      faMailbox,
      faTwitter,
    };
  },
  computed: {
    pageTitle() {
      return this.$t('nav.about');
    },
    pageDescription() {
      return `${this.$t('about.page_text_1')} ${this.$t('about.page_text_2')}`;
    },
    twitterUrl() {
      switch (this.$i18n.locale) {
        case 'ja':
          return 'https://twitter.com/motionelements?ref_src=twsrc%5Etfw';
        default:
          return false;
      }
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.about'),
          link: this.$link('/about').fullPath(),
          active: true,
        },
      ];
    },
  },
};
